import React, { Component } from 'react';
import DocumentosExternosPage from './documentos-externos.page';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../../pages/laudo/etapas/material/material.action';
import * as commonActions from '@common/common.action';
import WebapiCommon from '../../../app/common/util/webapi.common';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import { acessoPermitido } from '../../../acessos.seguranca';
import { IntlContext } from 'react-intl';
import IntlMessage from '../../../helpers/intlMessage';

class DocumentosExternosContainer extends Component {
  constructor() {
    super();
    this.state = {
      nomeDocumento: undefined,
    };
  }

  render() {
    return (
      <DocumentosExternosPage
        usuario={this.props.usuario}
        nomeDocumento={this.state.nomeDocumento}
        listagemDocumentosExternos={this.props.listagemDocumentosExternos}
        recebimentoFinalizado={this.props.recebimentoFinalizado}
        atualizarNomeDocumento={this.atualizarNomeDocumento.bind(this)}
        registrarRecebimentoDocExterno={this.registrarRecebimentoDocExterno.bind(
          this
        )}
        acessoPermitido={acessoPermitido}
        altura={this.props.altura}
        exameFinalizado={this.props.exameFinalizado}
      />
    );
  }

  atualizarNomeDocumento(event) {
    this.setState({
      nomeDocumento: event.currentTarget.value,
    });
  }

  registrarRecebimentoDocExterno() {
    const usuario = getUsuarioLocalStorage();
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.registrarRecebimentoDocExterno(this.props.detalhes.laudo, {
      nomeDocumento: this.state.nomeDocumento,
      nomeResponsavel: usuario.usuario,
    }).then(() => {
      WebapiCommon.obterListagemDocumentosLaudo(this.props.detalhes.laudo).then(
        (listagem) => {
          this.props.commonActions.atualizarListagemDocumentosExternos(
            listagem
          );
          this.setState({
            nomeDocumento: '',
          });
          this.props.commonActions.showFadeCarregando(false);
          this.props.commonActions.showAlerta(
            'sucesso',
            <IntlMessage id = "dashboards.examDetail.documentRegistered"/>,
            1500
          );
        }
      );
    });
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    detalhes: state.commonReducer.detalhes,
    listagemDocumentosExternos: state.commonReducer.listagemDocumentosExternos,
    recebimentoFinalizado: state.recebimentoMaterial.recebimentoFinalizado,
    exameFinalizado: state.commonReducer.exameFinalizado,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentosExternosContainer);



// WEBPACK FOOTER //
// ./src/app/common/documentosExternos/documentos-externos.container.js